import ProjectPageContainer from 'src/components/ProjectPageContainer';

import JobsTab from './ManageProject/JobsTab';

export default function ProjectJobs(): JSX.Element {
  return (
    <ProjectPageContainer>
      {(projectId, modalityLabel) => (
        <JobsTab projectId={projectId} modality={modalityLabel} />
      )}
    </ProjectPageContainer>
  );
}
